import { getRequest, postRequest, deleteRequest, publicGetRequest } from './api';

const organizationApi = {
  async getMembers() {
    return getRequest('/api/organization/members');
  },
  async getInvitations() {
    return getRequest('/api/organization/invitations');
  },
  async createInvitation(email) {
    return postRequest('/api/organization/invitations', { email });
  },
  async revokeInvitation(inviteId) {
    return deleteRequest(`/api/organization/invitations/${inviteId}`);
  },
  async getInviteInfo(token) {
    return publicGetRequest('/api/organization/invite-info', { token });
  },
};

export default organizationApi;
